import { Flex } from "@chakra-ui/react";
import Divider from "src/components/Menu/Divider";

export default function SectionDivider() {
  return (
    <Flex height="100%">
      <Divider height="100% !important" width="0.5px" />
    </Flex>
  );
}
